import logo from './logo.svg';
import WeddingInvitation from './WeddingInvitation';
import './App.css';

function App() {
   return (
    <div className="App">
      <WeddingInvitation />
    </div>
  );
}

export default App;
